<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="container">
      <div class="row">
        <div class="row">
          <UploadMedia @isUploadSuccessful="getUploadSuccessEvent"></UploadMedia>
        </div>
        <h1>Media</h1>
        <div class="col-lg-10 col-md-8 col-sm-6">
          <div v-if="loading">
            <div class="text-center mb-3 d-flex justify-content-between">
              <b-spinner variant="primary"></b-spinner>
            </div>
          </div>
          <div v-else>
            <div class="row border rounded"
                 style="max-height: 70vh; overflow-y: scroll;padding-block: 10px; background-color: rgb(255, 250, 250);">
              <div v-for="(info, index) in mediaArray" :key="index" class="col-lg-2 col-md-3 col-sm-6">
                <div class="mb-2">
                  <div class="rounded border" style=" background-color: white; ">
                    <!-- height: 140px;width: 140px; -->
                    <div :class="media.media_file_id == info.media_file_id ? 'border  border-primary' : ''"
                         style="text-align: center;"
                         @click="editMedia = true; media = info; getImageDimensions(index, info)">
                      <div v-if="info.media_file_type === 'image'">
                        <img :src="info.thumbnail_file_path_show" class="img-thumbnail"
                             style="height: 110px; width: 110px;" @error="handleImageError">
                      </div>
                      <template v-else-if="info.media_file_type === 'video'">
                        <video controls height="100%" width="100%">
                          <source :src="info.file_path_show" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>
                      </template>
                      <template v-else-if="info.media_file_type === 'audio'">
                        <audio controls>
                          <source :src="info.file_path_show" type="audio/mpeg">
                          Your browser does not support the audio element.
                        </audio>
                      </template>
                      <div v-else-if="info.media_file_type === 'pdf'">
                        <div style="text-align: center; height: 110px; padding: 15px;">
                          <img alt="" src="@/assets/img/pdf_icon.svg" style="height: 40px; width: 40px;">
                          <div class="titleText" style="overflow: hidden; word-wrap: break-word; ">
                            {{ info.media_file_name }}
                          </div>
                        </div>
                      </div>
                      <!--                    others-->
                      <template v-else>
                        <div
                            style="text-align: center; height: 110px; padding: 10px;"
                            @click="editMedia = true; media = info"
                        >
                          <img alt="" src="@/assets/unknown.png" style="height: 40px; width: 40px;">
                          <div class="titleText">
                            {{ info.media_file_name }}
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-6">
          <div class="p-2 rounded border" style="background-color: white;">
            <h5 class="">Information</h5>
            <div v-if="media.media_file_id != ''">
              <div class="mb-3">
                <template v-if="media.media_file_type === 'image'">
                  <img :src="media.file_path_show" alt="media" class="img-thumbnail">
                </template>
                <template v-else-if="media.media_file_type === 'video'">
                  <video controls height="100%" width="100%">
                    <source :src="media.file_path_show" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </template>
                <template v-else-if="media.media_file_type === 'audio'">
                  <audio controls>
                    <source :src="media.file_path_show" type="audio/mpeg">
                    Your browser does not support the audio element.
                  </audio>
                </template>
                <template v-else-if="media.media_file_type === 'pdf'">
                  <div>
                    <!-- <i class="fa-regular fa-file-pdf p-4"></i> -->
                  </div>
                </template>
                <template v-else>
                  <img :src="media.file_path_show" alt="media" class="img-thumbnail">
                </template>
              </div>
              <p class="text-wrap" style="font-weight: 600; font-size: 14px;word-break: break-word;">{{
                  media.media_file_name
                }} </p>
              <div style="font-size: 10px; color: grey;">{{ media.file_size }}</div>
              <div v-if="media.imageHeight != null" style="font-size: 10px; color: grey;">{{ media.imageWidth }} by {{
                  media.imageHeight
                }} pixels
              </div>
              <div style="font-size: 12px;">{{ format_date(media.insert_date) }}</div>
              <a class="text-danger" href="javascript:void(0)" type="button" @click="deleteMedia(media.media_file_id)">
                Delete Media
              </a>
            </div>
            <input v-model="media.file_path_show" class="form-control" placeholder="File Path" readonly type="text">
            <button class="btn btn-primary btn-sm mt-2" type="button" @click="copyPath">Copy Path</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaService from "@/services/media.service";
import Config from '@/config/index.js';
import UploadMedia from '@/components/Media/UploadMedia.vue';
import {format_date_mmddyyyy} from "@/helpers";
import {notify} from "@kyvg/vue3-notification";

export default {
  name: 'showAllMedia',
  data() {
    return {
      itemsBread: [{
        text: 'Home',
        to: '/dashboard'
      },
        {
          text: 'Media',
          to: '/album/show'
        },
        {
          text: 'Media Library',
          href: '#'
        }
      ],
      loading: false,
      mediaArray: [],
      editMedia: false,
      media: {
        media_file_id: '',
        media_file_type: '',
        media_file_name: '',
        file_path: '',
        insert_by: '',
        insert_date: '',
      },
      imageHeight: null,
      imageWidth: null,
    };
  },
  components: {
    UploadMedia,
  },
  mounted() {
    this.fetchMedia();
  },
  methods: {
    getUploadSuccessEvent(data) {
      if (data == true) {
        this.fetchMedia();
      }
    },

    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Upload Media',
        text: message
      });
    },

    async fetchMedia() {
      this.loading = true;
      this.mediaArray = [];
      this.editMedia = false;
      this.media = {
        media_file_id: '',
        media_file_type: '',
        media_file_name: '',
        file_path: '',
        insert_by: '',
        insert_date: '',
      };
      await MediaService.getAllMedia()
          .then(response => {
            this.loading = false;
            this.mediaArray = response.data;
            //iterate through the array and add the file path
            this.mediaArray.forEach(element => {
              element.file_path_show = Config.apiPortalFileBasePath + element.file_path;
              element.thumbnail_file_path_show = Config.apiFileBasePath + "/thumbnail" + element.thumbnail_file_path;
            });
            // console.log('file paths', this.mediaArray);
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
          });
    },

    copyPath() {
      const el = document.createElement('textarea');
      el.value = this.media.file_path_show;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      //show notification
      this.showNotification('success', 'Path copied to clipboard');
    },
    async deleteMedia(id) {
      const result = await this.$swal({
        icon: "warning",
        title: "Are you sure, you want to delete the Media?",
        text: "You won't be able to revert this deletion!",
        // title: 'Are you sure, you want to delete the User?',
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#007bff',
        showConfirmButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#dd3333',
      });
      if (result.isConfirmed) {
        this.loading = true;
        var response;
        try {
          response = await MediaService.deleteMedia(id);
        } catch (error) {
          notify({
            type: 'error',
            title: 'Delete Media',
            text: "Something went wrong",
          });
          this.loading = false;
        }
        this.loading = false;
        if (response.data.messageCode == 1) {
          notify({
            type: 'success',
            title: 'Delete Media',
            text: response.data.message,
          });
          this.fetchMedia();
        } else {
          notify({
            type: 'error',
            title: 'Delete Media',
            text: response.data.message,
          });
        }
      }

    },
    format_date(value) {
      return format_date_mmddyyyy(value);
    },
    async getImageDimensions(index, imageinfo) {
      const img = new Image();
      img.src = imageinfo.file_path;
      img.onload = () => {
        this.mediaArray[index].imageWidth = img.width;
        this.mediaArray[index].imageHeight = img.height;
      };
    },
    handleImageError(event) {
      // Update the image source to the dummy image when an error occurs
      event.target.src = "https://demofree.sirv.com/nope-not-here.jpg";
    },

  }
}

</script>

<style scoped>
.titleText {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* number of lines to show */
  line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
</style>